@if (isLoadingRegisterUserData()) {
  <app-loader-1 />
} @else if(registerUser()) {
  @if (isLoadingFirstCustomRoute()) {
    <app-geolocation-request />
    <app-loader-carousel />
  } @else {
    <main class="route-container__register-user">
      <form
        #formRef
        class="register-user__form" 
        [formGroup]="form"
      >
       @if (isMobile()) {
        <app-register-user-form-mobile 
          [form]="form"
          (submitFormEmitter)="handleSubmit()"
        />
        
       } @else {
        <app-register-user-form-desktop 
          [form]="form"
          (submitFormEmitter)="handleSubmit()"
        />
       }
      </form>  
    </main>
  }
}